import React from "react";

const HealthCheckPage = () => {
  return (
    <div style={{
      textAlign: "center",
      marginTop: "50px",
      fontFamily: "Arial, sans-serif",
      color: "#333"
    }}>
      <h1 style={{ fontSize: "2.5rem", marginBottom: "20px" }}>Security360 Portal</h1>
      <p style={{ fontSize: "1.2rem", marginBottom: "10px" }}>
        Status: <span style={{ color: "green", fontWeight: "bold" }}>Healthy</span>
      </p>
      <p style={{ fontSize: "1rem", color: "#555" }}>
        The Security360 portal is active and running smoothly. All services are operational.
      </p>
    </div>
  );
};

export default HealthCheckPage;
